import React, {useEffect, useState} from 'react';
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import image from './images/ads_image.png';
import {Globe2} from "react-bootstrap-icons";
// @ts-ignore
import Levels from 'react-activity/lib/Levels';
import 'react-activity/lib/Levels/Levels.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

let languages = {
    'en': "English",
    "de": "Deutsche",
    "ru": "Русский",
    "uk": "Українська"
}
const defaultLanguage = Object.keys(languages)[0]
const data = require('./constants/privacy.json')

const API_URL = "https://seabattle-server.herokuapp.com"

function App() {
    const [html, setHtml] = useState("")
    const [language, setLanguage] = useState(Object.entries(languages)[0][0])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
       setHtml(data.privacy)
    }, [])
    useEffect(()=>{
        if(language !== defaultLanguage) {
            setLoading(true)
            fetch(`${API_URL}/translatePrivacy`, {method: "POST", headers: {
                    "x-api-key" : "52cec3be3f93d1bc626138d96724211f",
                    "Content-Type": "application/json",
                }, body: JSON.stringify({text: data.privacy, to: language})})
                .then((then: any) => then.json())
                .then((then: any) => {
                    setHtml(then?.data?.[0]?.translations?.[0].text ?? data.privacy)
                })
                .catch((error: any) => console.log("error", error))
                .finally(() => {
                    setLoading(false)
                })
        }else{
            setHtml(data.privacy)
        }
    }, [language])


    return (
        <div className="App">
            <div className={"Header"}>
                <img src={image} alt={"logo"} className={"Image"}/>
            </div>
            <DropdownButton
                id="dropdown-item-button"
                onSelect = {(value: any) => {setLanguage(value)}}
                style={{position: "absolute", right: '1em', top: '1em'}}
                // @ts-ignore
                title={<span><Globe2 size={20} color="white" style={{marginRight: 10}}/>{languages?.[language]}</span>}
            >
                {Object.entries(languages).map (item => <Dropdown.Item eventKey={item[0]} key={item[0]}>{item[1]}</Dropdown.Item>)}
            </DropdownButton>
            {html && <div dangerouslySetInnerHTML={{__html: html}} style={{padding: '2em'}}></div>}
            {loading && <div style={{position: 'absolute', alignSelf: "center",  margin: "50vh auto 0",
                transform: "translateY(-50%)"}}><Levels  size={50}/></div>}

        </div>
    );
}

export default App;
